/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Logo, theme } from '@xometry/xometry_loft';
import Prismic from '@prismicio/client';
import MarketingPanel from './MarketingPanel';
import PrismicClient from '../../../services/prismic';

export type Props = {
  authenticated: boolean;
  flow: string;
} & React.ComponentProps<'div'>;

const RegisterLayout = (props: Props) => {
  const { authenticated, children, flow } = props;
  const [marketingData, setMarketingData] = useState();

  const pullPrismicData = () => {
    // if a cached version of the marketingData is already on the page, use that marketingData.
    if (
      sessionStorage.getItem(`xometry-pay-${flow}-onboarding-prismic-content`)
    ) {
      const storedData = sessionStorage.getItem(
        `xometry-pay-${flow}-onboarding-prismic-content`
      );
      if (storedData) {
        const response = JSON.parse(storedData);
        setMarketingData(response.results[0].data);
      }
    } else {
      const titleCaseFlow = flow.charAt(0).toUpperCase() + flow.slice(1);
      const tagName = `Xometry Pay ${titleCaseFlow}`;
      PrismicClient.query(Prismic.Predicates.at('document.tags', [tagName]))
        .then((response) => {
          setMarketingData(response.results[0].data);
          sessionStorage.setItem(
            `xometry-pay-${flow}-onboarding-prismic-content`,
            JSON.stringify(response)
          );
        })
        .catch(() => {
          // uncommented - this log causes the Jest test to fail in XACRegistration
          // console.error(error);
        });
    }
  };

  useEffect(() => {
    pullPrismicData();
    return () => {
      setMarketingData(undefined);
    }; // use effect cleanup to set flag false, if unmounted
  }, []);

  const handleLogInRedirect = () => {
    window.location.assign('/login');
  };

  // Adding the auth context provider here is a bit hacky, and we need to eventually
  // refactor this frontend to solely use the auth-context and federation to operate normally.
  return (
    <Flex height="100vh">
      <MarketingPanel marketingData={marketingData} />
      <Flex
        overflow="scroll"
        flexDirection="column"
        flex="1 1 auto"
        backgroundColor={theme.colors.white}
      >
        <Flex alignItems="center" marginTop={['0px', '0px', '0px', '40px']}>
          <Box display={['initial', 'initial', 'initial', 'none']}>
            <a href="/suppliers">
              <Logo
                logoType="fullLogo"
                height="38px"
                marginLeft={['16px', '36px']}
                marginTop="36px"
                alt="Xometry Logo"
              />
            </a>
          </Box>
          {!authenticated && (
            <>
              <Box marginLeft="auto" display={['none', 'initial']}>
                Already have a Xometry account?
              </Box>
              <Button
                kind="outline-blue"
                marginLeft={['auto', '16px']}
                marginRight={['12px', '48px']}
                onClick={handleLogInRedirect}
              >
                Sign In
              </Button>
            </>
          )}
        </Flex>
        <Flex
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default RegisterLayout;
